// takes the studio name + the model home name and returns a url in the format
// `/model-homes/ravenna-charleston-classic`
export const formatModelHomeUrl = (
  studioName: string,
  hpName: string,
  exteriorName: string,
) => {
  const slugify = (str: string) =>
    str
      ?.trim()
      .toLowerCase()
      .replace(/[\s/\\]+/g, '-') // normalize space/slash to dash
      .replace(/[^a-z0-9-]/g, '') // keep only safe characters
      .replace(/--+/g, '-') // prevent double dashes
      .replace(/^-+|-+$/g, ''); // trim outer dashes

  const dynamicSegment = `${slugify(studioName)}-${slugify(hpName)}-${slugify(exteriorName)}`;
  return `/model-homes/${encodeURIComponent(dynamicSegment)}`;
};
